module.exports = __webpack_public_path__ + "img/markets.12a56967.svg";